// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "safetystandard/js/" + chunkId + "." + "f9ee006a" + ".js";
};